import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { CustomersDetailsDemoData } from '../../../../data';
import { useTemplate } from '../../../features/template/TemplateProvider';
import { useCustomer } from '../CustomerProvider';
import { handleGetCustomerDetails } from './CustomerDetailsOperation';

const CustomerDetailsContext = createContext();

export const useCustomerDetails = () => useContext(CustomerDetailsContext);

function CustomerDetailsProvider({ agencyId = 0, customerId, children }) {
    const { setMessage } = useTemplate();
    const [addressShow, setAddressShow] = useState(false);
    const [openAppInfoModal, setOpenAppInfoModal] = useState(false);
    const [addNewSubscriptionModal, setAddNewSubscriptionModal] = useState(false);
    const [customerDetailsData, setCustomerDetailsData] = useState(CustomersDetailsDemoData);
    // --Modal open handler
    const [showModal, setShowModal] = useState({
        type: '',
        data: null
    });

    // reload state
    const { infoReloadKey, setInfoReloadKey } = useCustomer();

    useEffect(() => {
        setCustomerDetailsData(CustomersDetailsDemoData);
        handleGetCustomerDetails(agencyId, customerId)
            .then(({ data }) => {
                setCustomerDetailsData(data);
            })
            .catch((error) => {
                setMessage({ type: 'error', text: error.toString(0) });
                setCustomerDetailsData({});
            });
    }, [customerId, setMessage, infoReloadKey]);

    const value = useMemo(() => {
        // -- Handle Reload
        const handleReload = () => {
            setInfoReloadKey((d) => d + 1);
        };

        // App info modal show/hide handler
        const handleAppInfoModal = () => setOpenAppInfoModal(true);
        const handleShowNewSubScription = () => setAddNewSubscriptionModal(true);

        // Address show hide handler
        const handleAddressBoxShow = () => setAddressShow((d) => !d);

        // --Handler to open modal
        const openModal = (type, data) => {
            setShowModal({
                type,
                data
            });
        };
        // --Handler to close modal
        const closeModal = () => {
            setShowModal({
                type: '',
                data: null
            });
        };

        return {
            openModal,
            closeModal,
            modalType: showModal?.type,
            modalData: showModal?.data,
            // customer details data
            customerDetailsData,
            setCustomerDetailsData,

            // Reload Key
            infoReloadKey,
            setInfoReloadKey,

            // modal control
            openAppInfoModal,
            setOpenAppInfoModal,
            addNewSubscriptionModal,
            setAddNewSubscriptionModal,

            // handle
            handleAppInfoModal,
            handleShowNewSubScription,
            handleReload,

            // Address Box show and Hide
            addressShow,
            setAddressShow,
            handleAddressBoxShow
        };
    }, [
        addNewSubscriptionModal,
        addressShow,
        customerDetailsData,
        infoReloadKey,
        openAppInfoModal,
        setInfoReloadKey,
        showModal.data,
        showModal.type
    ]);
    return (
        <CustomerDetailsContext.Provider value={value}>{children}</CustomerDetailsContext.Provider>
    );
}

export default CustomerDetailsProvider;
